/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-spread */
/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
import EDC from './globals';
import sound from 'phaser/src/sound';

/**
 *
 */
EDC.Preloaders.Thumbs = function (scene) {
  scene.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/thumbs-animations/');
  scene.load.setPrefix('thumbs-anim-');

  scene.load.image('thumb-up', 'thumb-up.png');
  scene.load.image('boom', 'boom.png');
  scene.load.image('yes', 'yes.png');
  scene.load.image('ice-cream', 'ice-cream.png');
  scene.load.image('wow', 'wow.png');
  scene.load.image('yes-tl', 'yes-tl.png');
  scene.load.image('yes-tr', 'yes-tr.png');
  scene.load.image('yes-bl', 'yes-bl.png');
  scene.load.image('yes-br', 'yes-br.png');

  scene.load.setPath();
  scene.load.setPrefix();

  scene.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/audio/sound-effects/');

  for (let i = 1; i < 6; i++) {
    scene.load.audio(`negative-${i}`, `negative/${i}.mp3`);
  }
  for (let i = 1; i < 13; i++) {
    scene.load.audio(`positive-${i}`, `positive/${i}.mp3`);
  }

  scene.load.setPath();
};
/**
 * Thumb up animation scene.
 */
EDC.Animations.Thumbs = function () {
  this.mainScene = null;
  this.correctCount = 0;
  this.wrongCount = 0;
  this.eventsNames = {
    THUMB_START: 'THUMB_START',
    THUMB_COMPLETE: 'THUMB_COMPLETE',
  };
  return this;
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.create = function () {
  this.events.on(this.eventsNames.THUMB_START, this.onAnimationStart, this);
  this.events.on(this.eventsNames.THUMB_COMPLETE, this.onAnimationComplete, this);
  return this;
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.onAnimationStart = function () {
  // if (this.mainScene) this.mainScene.scene.pause();
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.onAnimationComplete = function () {
  // if (this.mainScene) this.mainScene.scene.resume();
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.setMainScene = function (scene) {
  this.mainScene = scene;
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showCorrect = function () {
  this.correctCount += 1;
  this.wrongCount = 0;
  this.correctSound();
  this.showRandom();
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showWrong = function () {
  this.wrongSound();
};
EDC.Animations.Thumbs.prototype.wrongSound = function () {
  const soundCount = 5;
  const rndIndex = 1 + Math.floor(Math.random() * soundCount);
  const musicArray = this.sound.getAll();
  for (let i = 0; i < musicArray.length; i++) {
    musicArray[i].setVolume(0.1);
  }
  const music = this.sound.add(`negative-${rndIndex}`);
  music.play();
  music.once(
    'complete',
    (music) => {
      const musicArray = this.sound.getAll();
      for (let i = 0; i < musicArray.length; i++) {
        musicArray[i].setVolume(1);
      }
      music.destroy();
    },
    this,
  );
};

EDC.Animations.Thumbs.prototype.correctSound = function () {
  const soundCount = 12;
  const rndIndex = 1 + Math.floor(Math.random() * soundCount);
  const musicArray = this.sound.getAll();
  for (let i = 0; i < musicArray.length; i++) {
    musicArray[i].setVolume(0.1);
  }
  const music = this.sound.add(`positive-${rndIndex}`);
  music.play();
  music.once(
    'complete',
    function (music) {
      const musicArray = this.sound.getAll();
      for (let i = 0; i < musicArray.length; i++) {
        musicArray[i].setVolume(1);
      }
      music.destroy();
    },
    this,
  );
};

/**
 *
 */
EDC.Animations.Thumbs.prototype.showRandom = function () {
  const methodsNames = ['showIcecream', 'showBoom', 'showOneThumb', 'showTwoThumbs', 'showWow', 'showYesParts'];
  const rndIndex = Math.floor(Math.random() * methodsNames.length);
  const selectedMethod = methodsNames[rndIndex];
  this[selectedMethod].apply(this, arguments);
  this.events.emit(this.eventsNames.THUMB_START);
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showOneThumb = function () {
  const sprite = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'thumbs-anim-thumb-up');
  sprite.setScale(0);
  this.tweens.add({
    targets: sprite,
    scaleX: 0.8,
    scaleY: 0.8,
    duration: 400,
    ease: 'Back.easeOut',
    onComplete: function (thumbSprite) {
      this.tweens.add({
        targets: thumbSprite,
        alpha: 0,
        duration: 300,
        delay: 250,
        ease: 'Linear',
        onComplete: function (thumbToDestroy) {
          thumbToDestroy.destroy();
          this.events.emit(this.eventsNames.THUMB_COMPLETE);
        }.bind(this, thumbSprite),
      });
    }.bind(this, sprite),
  });
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showIcecream = function () {
  const ice = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'thumbs-anim-ice-cream');
  ice.setAlpha(0);
  this.tweens.add({
    targets: ice,
    alpha: 1,
    duration: 200,
    ease: 'Linear',
    onComplete: function (ice) {
      this.tweens.add({
        targets: ice,
        angle: 15,
        duration: 100,
        repeat: 2,
        yoyo: true,
        onComplete: function () {
          this.tweens.add({
            targets: ice,
            alpha: 0,
            duration: 200,
            ease: 'Linear',
            onComplete: function () {
              ice.destroy(),
              this.events.emit(this.eventsNames.THUMB_COMPLETE);
            }.bind(this, ice),
          });
        }.bind(this, ice),
      });
    }.bind(this, ice),
  });
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showBoom = function () {
  const boomSprite = this.add.sprite(0, this.game.config.height / 2, 'thumbs-anim-boom');
  boomSprite.x = -boomSprite.displayWidth / 2;
  this.tweens.add({
    targets: boomSprite,
    x: this.game.config.width / 2,
    duration: 350,
    easeParams: [2.4],
    ease: 'Back.easeOut',
    onComplete: function (boomSprite) {
      this.tweens.add({
        targets: boomSprite,
        x: this.game.config.width + boomSprite.displayWidth / 2,
        duration: 350,
        easeParams: [2.4],
        ease: 'Back.easeIn',
        delay: 200,
        onComplete: function (boomSprite) {
          boomSprite.destroy();
          this.events.emit(this.eventsNames.THUMB_COMPLETE);
        }.bind(this, boomSprite),
      });
    }.bind(this, boomSprite),
  });
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showTwoThumbs = function () {
  const spriteLeft = this.add.sprite(0, this.game.config.height / 2, 'thumbs-anim-thumb-up');
  spriteLeft.setScale(0.5);
  spriteLeft.setFlipX(true);
  spriteLeft.x = -spriteLeft.width / 2;
  this.tweens.add({
    targets: spriteLeft,
    x: this.game.config.width / 2 - (spriteLeft.width * spriteLeft.scaleX) / 2,
    duration: 600,
    ease: 'Bounce.easeOut',
    onComplete: function (spriteLeft) {
      this.tweens.add({
        targets: spriteLeft,
        alpha: 0,
        duration: 200,
        delay: 100,
        ease: 'Linear',
        onComplete: function (spriteLeft) {
          spriteLeft.destroy();
          this.events.emit(this.eventsNames.THUMB_COMPLETE);
        }.bind(this, spriteLeft),
      });
    }.bind(this, spriteLeft),
  });

  const spriteRight = this.add.sprite(0, this.game.config.height / 2, 'thumbs-anim-thumb-up');
  spriteRight.setScale(0.5);
  spriteRight.x = this.game.config.width + spriteRight.width / 2;
  this.tweens.add({
    targets: spriteRight,
    x: this.game.config.width / 2 + (spriteRight.width * spriteRight.scaleX) / 2,
    duration: 600,
    ease: 'Bounce.easeOut',
    onComplete: function (spriteRight) {
      this.tweens.add({
        targets: spriteRight,
        alpha: 0,
        duration: 200,
        delay: 100,
        ease: 'Linear',
        onComplete: function (spriteRight) {
          spriteRight.destroy();
        }.bind(this, spriteRight),
      });
    }.bind(this, spriteRight),
  });
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showWow = function () {
  const wowSprite = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'thumbs-anim-wow');
  wowSprite.setScale(0);
  this.tweens.add({
    targets: wowSprite,
    duration: 250,
    scaleX: 1,
    scaleY: 1,
    angle: 360,
    ease: 'Linear',
    onComplete: function (wowSprite) {
      this.tweens.add({
        targets: wowSprite,
        scaleX: 3,
        scaleY: 3,
        angle: wowSprite.angle + 360,
        alpha: 0,
        duration: 250,
        ease: 'Linear',
        delay: 400,
        onComplete: function (wowSprite) {
          wowSprite.destroy();
          this.events.emit(this.eventsNames.THUMB_COMPLETE);
        }.bind(this, wowSprite),
      });
    }.bind(this, wowSprite),
  });
};
/**
 *
 */
EDC.Animations.Thumbs.prototype.showYesParts = function () {
  const parts = {
    tl: {
      sx: 0,
      sy: 0,
      ox: 1,
      oy: 1,
    },
    tr: {
      sx: this.game.config.width,
      sy: 0,
      ox: 0,
      oy: 1,
    },
    bl: {
      sx: 0,
      sy: this.game.config.height,
      ox: 1,
      oy: 0,
    },
    br: {
      sx: this.game.config.width,
      sy: this.game.config.height,
      ox: 0,
      oy: 0,
    },
  };

  for (const prop in parts) {
    const partData = parts[prop];
    const partSprite = this.add.sprite(partData.sx, partData.sy, `thumbs-anim-yes-${prop}`);
    partSprite.setOrigin(partData.ox, partData.oy);
    partSprite.setScale(0);
    this.tweens.add({
      targets: partSprite,
      x: this.game.config.width / 2,
      y: this.game.config.height / 2,
      scaleX: 1,
      scaleY: 1,
      ease: 'Linear',
      duration: 200,
      onComplete: function (partSprite, prop) {
        this.tweens.add({
          targets: partSprite,
          scaleX: 1.2,
          scaleY: 1.2,
          duration: 250,
          yoyo: true,
          ease: 'Linear',
          delay: 50,
          onComplete: function (partSprite, prop) {
            this.tweens.add({
              targets: partSprite,
              scaleX: 0,
              scaleY: 0,
              duration: 200,
              ease: 'Linear',
              delay: 100,
              onComplete: function (partSprite, prop) {
                partSprite.destroy();
                if (prop === 'tl') {
                  this.events.emit(this.eventsNames.THUMB_COMPLETE);
                }
              }.bind(this, partSprite, prop),
            });
          }.bind(this, partSprite, prop),
        });
      }.bind(this, partSprite, prop),
    });
  }
};

const exportPreloader = EDC.Preloaders.Thumbs;
const exportThumbs = EDC.Animations.Thumbs;

export { exportPreloader as ThumbsPreloader, exportThumbs as Thumbs };
